module.exports = __webpack_public_path__ + "media/images/salespartner/bg-cta-left-4942ecaf010108a44855b1d3b90cf517.svg";